import Icon from 'veui/components/Icon'

Icon.register({
  image: {
    paths: [
      {
        d: 'M704 96H64a32 32 0 00-32 32v544a32 32 0 0032 32h640a32 32 0 0032-32V128a32 32 0 00-32-32zm-32 64v306.74L534.63 329.37a32 32 0 00-45.26 0L352 466.75l-73.37-73.38a32 32 0 00-45.26 0L96 530.74V160zM96 640v-18.74l160-160 73.37 73.38a32 32 0 0045.26 0L512 397.25l160 160V640zm160-361a40 40 0 1140 40 40 40 0 01-40-40z'
      }
    ],
    width: '768',
    height: '768'
  }
})
